export const pricingTypeConstant = Object.freeze({
  part: 'part',
  labor: 'labor',
  other: 'other',
  motorTimeMarkup: 'motor_time_markup',
});
